<template>
  <div class="product_box2 flex-r-s-s">
    <div class="pro_info flex-r-s-s">
      <van-image width="2.56rem" height="2.56rem" class="pro_info_img" :src="myinfo.saleIconUrl " @click="jumpDetail(myinfo.productId)" />
      <div class="cart_pro_info" style="width:6.4rem;">
        <div class="cart_pro_info_top">
          <div class="pro_name van-multi-ellipsis--l2" style="width:6rem;margin-top:0rem;padding-top:0.28rem"
               @click="jumpDetail(myinfo.productId)"
          >
            {{ myinfo.saleName }}</div>
          <div class="pro_brand_model van-ellipsis" style="width:6rem;color:#333"
               @click="jumpDetail(myinfo.productId)"
          >
            {{ myinfo.brand }} | {{ myinfo.specifications }}</div>
          <div v-if="myinfo.minQuantity>1" class="pro_brand_model van-ellipsis" style="width:6rem"
               @click="jumpDetail(myinfo.productId)"
          >
            最低起售量：{{ myinfo.minQuantity }}</div>
        </div>
        <!-- <div class="pro_tags">1</div> -->
        <div class="pro_bottom pro_bottom_cart  flex-r-sb-c" style="width:6rem">
          <div class="pro_money">￥<span style="font-size: 0.49rem;">{{ myinfo.salePrice }}</span></div>
          <div class="pro_btn flex-r-c-c">
            <van-stepper v-if="myinfo.priceNum > 0 || myinfo.priceNum === ''" v-model="myinfo.priceNum"
                         :step="myinfo.multiplyQuantity === 1 ? myinfo.minQuantity : 1" :min="0" integer
                         :allow-empty="true" input-width="1rem" button-size="0.5rem" theme="round" @change="changeNum"
                         @focus="focusInput" @blur="blurInput" @minus="changeNumminus" @plus="changeNumplus"
            />
            <!-- $event.target.select() -->
            <van-icon v-else name="add" color="#0767AB" size="0.55rem" @click="addNum" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { wholesalePreferential_addCart, wholesalePreferential_delCart } from '@/api/pro'
export default {
  props: {
    info: { type: Object, default: () => { } },
    id: { type: Number, default: null },
    pmid: { type: String, default: '' },
    length: { type: Number, default: null },
    cannum: { type: Number, default: null }
  },
  data() {
    return {
      myinfo: this.info,
      mycanBuyNum: this.cannum === -1 ? 9999 : this.cannum
    }
  },
  methods: {

    // 进入详情
    jumpDetail(productId) {
      sessionStorage.setItem('classify_pro_id', 'pro_' + this.id)
      this.$router.push('/product/detail_cart?productId=' + productId + '&productModuleId=' + this.pmid)
    },
    focusInput() { this.myinfo.priceNum = '' },
    blurInput(e) {
      if (this.myinfo.priceNum === '') {
        wholesalePreferential_delCart({ productId: this.myinfo.productId, productModuleId: this.pmid }).then(res => { this.$emit('changeNum', res.data) })
        this.myinfo.priceNum = 0
      } else {
        var val = this.myinfo.priceNum * 1
        wholesalePreferential_addCart({ productId: this.myinfo.productId, productModuleId: this.pmid, priceNum: val }).then(res => {
          this.$emit('changeNum', res.data)
        })
      }
    },
    addNum() {
      wholesalePreferential_addCart({ productId: this.myinfo.productId, productModuleId: this.pmid, priceNum: parseInt(this.myinfo.minQuantity) }).then(res => {
        this.myinfo.priceNum = parseInt(this.myinfo.minQuantity)
        this.$emit('changeNum', res.data)
      })
    },
    // 修改数量
    changeNum(val) {
      var minQuantity = parseInt(val) % parseInt(this.myinfo.minQuantity) === 0
      console.log(minQuantity)
      if (parseInt(val) > 0 && minQuantity) {
        wholesalePreferential_addCart({ productId: this.myinfo.productId, priceNum: val, productModuleId: this.pmid }).then(res => {
          this.$emit('changeNum', res.data)
        })
        // if (!minQuantity) { this.myinfo.priceNum = parseInt(this.myinfo.minQuantity) }
      } else if (parseInt(val) === 0) {
        wholesalePreferential_delCart({ productId: this.myinfo.productId, productModuleId: this.pmid }).then(res => { this.$emit('changeNum', res.data) })
        this.myinfo.priceNum = 0
      }
      this.$forceUpdate()
    },
    changeNumminus() {
      var step = this.myinfo.multiplyQuantity === 1 ? this.myinfo.minQuantity : 1
      var val = this.myinfo.priceNum * 1 - step * 1
      wholesalePreferential_addCart({ productId: this.myinfo.productId, priceNum: val, productModuleId: this.pmid }).then(res => {
        this.$utils.debounce(() => {
          this.$emit('changeNum', res.data)
        }, 50)()
      })
    },
    changeNumplus() {
      var step = this.myinfo.multiplyQuantity === 1 ? this.myinfo.minQuantity : 1
      var val = this.myinfo.priceNum * 1 + step * 1
      wholesalePreferential_addCart({ productId: this.myinfo.productId, priceNum: val, productModuleId: this.pmid }).then(res => {
        this.$utils.debounce(() => {
          this.$emit('changeNum', res.data)
        }, 50)()
      })
    }
  }
}
</script>

<style>
.pro_btn .van-stepper--round .van-stepper__minus {
  border: 0.03rem solid #e2e2e2;
  color: #000;
}
.pro_btn .van-stepper--round .van-stepper__plus {
  background-color: rgba(7, 103, 171, 1);
}
.product_box_cart {
  border-bottom: 2px solid #f7f7f7;

  margin-top: 0rem;
}
.cart_product_box_cart {
  width: 9.47rem;
  height: 3rem;
  border-radius: 0.27rem;
  background: #ffffff;
}
.cart_pro_info_top {
}
.pro_bottom_cart {
}
</style>

<style lang="scss">
// 商品card-box-
.product_box2 {
  width: 9.47rem;
  min-height: 3rem;
  border-radius: 0.27rem;
  background: #ffffff;

  margin-top: 0.21rem;
  .pro_info {
    border-radius: 0.2rem;
    background: #fff;
    height: 100%;
    .pro_info_img{
      padding-top: 0.32rem;
      padding-left: 0.32rem;
    }
    .van-image {
      border-radius: 0.2rem;
      .van-image__img {
        border-radius: 0.2rem;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
    .pro_name {
      padding-left: 0.32rem;
      width: 3.73rem;
      font-size: 0.37rem;
      font-weight: 400;
      color: #000000;

      margin-top: 0.16rem;
      text-align: left;
      .van-image {
        .van-image__img {
          border-radius: 0rem;
        }
      }
    }
    .presell_pro {
      .van-image {
        .van-image__img {
          border-radius: 0rem;
        }
      }
    }
    .presell_pro-top {
      .van-image {
        .van-image__img {
          padding-top: 0.08rem;
        }
      }
    }
    .pro_brand_model {
      padding-left: 0.32rem;
      width: 3.73rem;
      font-size: 0.32rem;
      font-weight: 400;
      color: #999999;

      margin-top: 0.11rem;
      text-align: left;
    }
    .pro_tags {
      margin-left: 0.32rem;
      margin-top: 0.16rem;
      margin-bottom: 0.27rem;
      width: 1.92rem;
      height: 0.45rem;
      background: #f0f9ff;
      // border: 1px solid #0767ab;
      border-radius: 0.11rem;
      font-size: 0.29rem;
      .pro_tags_item {
        width: 1.92rem;
        min-height: 0.45rem;
        border: 0.01rem solid #0767ab;
        border-radius: 0.11rem;
      }
    }
    .pro_bottom {
      padding-left: 0.32rem;
      width: 90%;
      margin-top: 0.37rem;
      margin-bottom: 0.37rem;
      .pro_money {
        height: 0.59rem;
        font-size: 0.29rem;
        color: #ed0d0d;
        line-height: 0.59rem;
        font-weight: bold;
      }
      .pro_btn {
        line-height: 0.59rem;
        color: #0767ab;
        font-size: 0.49rem;
      }
      .pro_vip_btn {
        width: 4.11rem;
        height: 1.07rem;
        line-height: 1.07rem;
        border-radius: 0.53rem;

        font-size: 0.48rem;
      }
      .vip_no {
        background: #cfcfcf;
        color: #fff;
      }
      .vip_can {
        background: #f3d1ac;
        color: #673b15;
      }
    }
  }
}
</style>
